import type { FeedPage } from '~/composables/shorts/useFetchShorts';

/** Lista e alvo entregues pela superfície que abriu o feed. */
export interface ShortsFeedHandoff {
	page: FeedPage;
	at: string;
}

export function useShortsFeedHandoff() {
	return useState<ShortsFeedHandoff | null>('shorts-feed-handoff', () => null);
}

/** O handoff é transitório e só pode ser consumido uma vez. */
export function consumeShortsFeedHandoff(): ShortsFeedHandoff | null {
	const handoff = useShortsFeedHandoff();
	const current = handoff.value;
	handoff.value = null;
	return current;
}
